let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1vHyq"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("6wPv6")]).then(() => parcelRequire('hEuLk'));